module.exports = __webpack_public_path__ + "img/ballena.f140fec2.gif";